// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --p1: #4f46e5;
  --p2: #818cf8;
  --grad: linear-gradient(135deg, #4f46e5 0%, #818cf8 100%);
  --green: #10B981;
  --bg: #f4f4f5;
  --surface: #ffffff;
  --card: #ffffff;
  --border: #e4e4e7;
  --text: #111827;
  --muted: #6b7280;
  --muted2: #9ca3af;
  --text-soft: #374151;
  --border-strong: #d4d4d8;

  /* Escala da marca e de erro usada pelo app */
  --brand-900: #312e81;
  --brand-800: #3730a3;
  --brand-700: #4338ca;
  --brand: #4f46e5;
  --brand-300: #a5b4fc;
  --brand-100: #e0e7ff;
  --brand-50: #eef2ff;

  --danger-700: #b91c1c;
  --danger: #dc2626;
  --danger-400: #f87171;
  --danger-100: #fee2e2;
  --danger-50: #fef2f2;

  --grad-brand: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);
  --grad-deep: linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%);

  --shadow-xs: 0 1px 2px rgba(17, 24, 39, 0.06);
  --shadow-sm: 0 2px 8px rgba(17, 24, 39, 0.06);
  --shadow: 0 8px 24px rgba(17, 24, 39, 0.08);
  --shadow-brand: 0 12px 32px rgba(79, 70, 229, 0.2);

  --radius-sm: 10px;
  --radius: 14px;
  --radius-lg: 20px;
  --radius-pill: 999px;

  --font-display: 'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --font-body: 'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; }
body {
  background: var(--bg);
  color: var(--text);
  font-family: 'Plus Jakarta Sans', sans-serif;
  overflow-x: hidden;
  line-height: 1.6;
}

button, input, select, textarea { font-family: inherit; }

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.reveal.visible { opacity: 1; transform: translateY(0); }

.grad-text {
  background: var(--grad);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.s-eye {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--p1);
  display: block;
  margin-bottom: 10px;
}

.s-title {
  font-size: clamp(1.7rem, 3vw, 2.4rem);
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1.15;
  margin-bottom: 12px;
  color: var(--text);
}

.s-sub { color: var(--muted); font-size: 0.97rem; line-height: 1.7; }

.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }

:focus-visible { outline: 3px solid var(--brand-300); outline-offset: 2px; }

.btn-primary,
.btn-outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  transition: opacity 0.2s, transform 0.15s, border-color 0.2s;
}

.btn-primary {
  background: var(--grad);
  color: #fff;
  border: none;
}
.btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }

.btn-outline {
  background: #fff;
  color: var(--p1);
  border: 2px solid var(--brand-100);
}
.btn-outline:hover { border-color: var(--p1); transform: translateY(-1px); }
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;;EAExB,6CAA6C;EAC7C,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;;EAEnB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;;EAEpB,+DAA+D;EAC/D,8DAA8D;;EAE9D,6CAA6C;EAC7C,6CAA6C;EAC7C,2CAA2C;EAC3C,kDAAkD;;EAElD,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;;EAEpB,qFAAqF;EACrF,kFAAkF;AACpF;;AAEA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;AACxE,OAAO,uBAAuB,EAAE;AAChC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kCAAkC,oBAAoB,EAAE;;AAExD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;AACA,kBAAkB,UAAU,EAAE,wBAAwB,EAAE;;AAExD;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEpE,aAAa,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEjE,iBAAiB,mCAAmC,EAAE,mBAAmB,EAAE;;AAE3E;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;AACA,qBAAqB,YAAY,EAAE,2BAA2B,EAAE;;AAEhE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;AACA,qBAAqB,uBAAuB,EAAE,2BAA2B,EAAE","sourcesContent":[":root {\n  --p1: #4f46e5;\n  --p2: #818cf8;\n  --grad: linear-gradient(135deg, #4f46e5 0%, #818cf8 100%);\n  --green: #10B981;\n  --bg: #f4f4f5;\n  --surface: #ffffff;\n  --card: #ffffff;\n  --border: #e4e4e7;\n  --text: #111827;\n  --muted: #6b7280;\n  --muted2: #9ca3af;\n  --text-soft: #374151;\n  --border-strong: #d4d4d8;\n\n  /* Escala da marca e de erro usada pelo app */\n  --brand-900: #312e81;\n  --brand-800: #3730a3;\n  --brand-700: #4338ca;\n  --brand: #4f46e5;\n  --brand-300: #a5b4fc;\n  --brand-100: #e0e7ff;\n  --brand-50: #eef2ff;\n\n  --danger-700: #b91c1c;\n  --danger: #dc2626;\n  --danger-400: #f87171;\n  --danger-100: #fee2e2;\n  --danger-50: #fef2f2;\n\n  --grad-brand: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);\n  --grad-deep: linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%);\n\n  --shadow-xs: 0 1px 2px rgba(17, 24, 39, 0.06);\n  --shadow-sm: 0 2px 8px rgba(17, 24, 39, 0.06);\n  --shadow: 0 8px 24px rgba(17, 24, 39, 0.08);\n  --shadow-brand: 0 12px 32px rgba(79, 70, 229, 0.2);\n\n  --radius-sm: 10px;\n  --radius: 14px;\n  --radius-lg: 20px;\n  --radius-pill: 999px;\n\n  --font-display: 'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  --font-body: 'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;\n}\n\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\nhtml { scroll-behavior: smooth; }\nbody {\n  background: var(--bg);\n  color: var(--text);\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  overflow-x: hidden;\n  line-height: 1.6;\n}\n\nbutton, input, select, textarea { font-family: inherit; }\n\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.reveal {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.6s ease, transform 0.6s ease;\n}\n.reveal.visible { opacity: 1; transform: translateY(0); }\n\n.grad-text {\n  background: var(--grad);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.s-eye {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: var(--p1);\n  display: block;\n  margin-bottom: 10px;\n}\n\n.s-title {\n  font-size: clamp(1.7rem, 3vw, 2.4rem);\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  line-height: 1.15;\n  margin-bottom: 12px;\n  color: var(--text);\n}\n\n.s-sub { color: var(--muted); font-size: 0.97rem; line-height: 1.7; }\n\n.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }\n\n:focus-visible { outline: 3px solid var(--brand-300); outline-offset: 2px; }\n\n.btn-primary,\n.btn-outline {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 12px;\n  padding: 14px 28px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n  font-family: inherit;\n  transition: opacity 0.2s, transform 0.15s, border-color 0.2s;\n}\n\n.btn-primary {\n  background: var(--grad);\n  color: #fff;\n  border: none;\n}\n.btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }\n\n.btn-outline {\n  background: #fff;\n  color: var(--p1);\n  border: 2px solid var(--brand-100);\n}\n.btn-outline:hover { border-color: var(--p1); transform: translateY(-1px); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
